import React, {useEffect, useState} from 'react';
import ModalNative from '../../../components/Modal';
import ModalJS from '../../../components/ModalJS';
import QRCode from 'react-native-qrcode-svg';
import Text from '../../../components/Text';
import Button from '../../../components/Button';
import {createUnitPeopleConnector} from '../../../api/connector';
import {showErrorMessage} from '../../../service/flashMessage';
import {RootStore} from '../../../redux/store';
import {useSelector} from 'react-redux';
import  LoadingSpinner  from '../../../components/LoadingSpinner';
import {copyToClipboard} from '../../../service/clipboard';
import {View} from 'react-native';
import {store} from '../../../redux/store';

const InviteCodeGenerator = ({modalVisible, closeModal}) => {
  const peopleId = useSelector((state: RootStore) => state?.auth?.user?.id);
  const [inviteCode, setInviteCode] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchLinkCode = async () => {
    try {
      const link = await createUnitPeopleConnector({
        expiration: new Date(
          new Date().setHours(new Date().getHours() + 24),
        ).toISOString(),
        note: '',
        peopleId,
      });
      setInviteCode(link.linkCode);
    } catch (e) {
      showErrorMessage('InviteCodeGenerator: ' + e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (modalVisible) {
      fetchLinkCode();
    }
    store.dispatch({
      type: 'InviteCodeGenerator',
      inviteCodeGeneratorModalVisible: modalVisible,
    });
  }, [modalVisible]);

  const Modal = ModalNative;

  return (
    <Modal isOpen={modalVisible} onClose={closeModal} size="xl">
      <Modal.Content>
        <Modal.CloseButton />
        <Modal.Header>Your invitation code is: </Modal.Header>
        <Modal.Body
          _scrollview={{
            keyboardShouldPersistTaps: 'handled',
          }}>
          {loading ? (
            <View
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}>
              <LoadingSpinner size="large" />
            </View>
          ) : (
            <>
              <Text>Share this code to owner or management office. </Text>
              <View
                style={{
                  rowGap: 12,
                }}>
                <Text
                  style={{
                    fontSize: 30,
                    flexWrap: 'wrap',
                    rowGap: 4,
                    display: 'flex',
                    lineHeight: 30,
                    textAlign: 'center',
                    paddingVertical: 10,
                  }}>
                  {inviteCode}
                </Text>
                <View
                  style={{
                    flex: 1,
                    marginLeft: 10,
                  }}>
                  <Button
                    onPress={() => {
                      copyToClipboard(inviteCode);
                      closeModal();
                    }}>
                    {'Copy '}
                  </Button>
                </View>
              </View>
              <View
                style={{
                  flexDirection: 'row',
                  justifyContent: 'center',
                  marginTop: 20,
                }}>
                <QRCode
                  // @ts-ignore
                  value={inviteCode}
                  size={100}
                />
              </View>
            </>
          )}
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
};

export default InviteCodeGenerator;
